import { render, staticRenderFns } from "./dataTransfer.vue?vue&type=template&id=e77b832e&scoped=true&"
import script from "./dataTransfer.vue?vue&type=script&lang=ts&"
export * from "./dataTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./dataTransfer.vue?vue&type=style&index=0&id=e77b832e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77b832e",
  null
  
)

export default component.exports